module.exports = __webpack_public_path__ + "img/icon_sec2_4@2x.64d97174.png";